var map = {
	"./BLR.ts": [
		54523,
		2483
	],
	"./KAZ.ts": [
		21604,
		8281
	],
	"./RUS.ts": [
		22003,
		8447
	],
	"./UZB.ts": [
		17062,
		5060
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 20551;
module.exports = webpackAsyncContext;